<template>
<div>
    <invoice-discount-format-list></invoice-discount-format-list>
</div>
</template>

<script>
export default {};
</script>
